var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "car ico"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 115",
    d: "M17.576 23.917a7.968 7.968 0 0112.981-3.977c-.007-.448-.024-.879-.01-1.244a2.831 2.831 0 00-1.026-2.238c.42-.04 1.369.185 1.492-.419.038-.344.485-1.309.163-1.609-.168-.414-2.9-.131-3.24-.209C26.403 9.303 24.303 9 19.358 9c-4.809 0-7.05.312-8.577 5.221-.355.085-3.057-.21-3.24.209-.322.3.125 1.267.163 1.609.121.6 1.075.38 1.492.419a2.831 2.831 0 00-1.026 2.238c.049 1.252-.285 3.233.746 4.195.078 1.23-.509 4.047 1.492 4.009 2.627.173 3.156-.358 2.984-2.983zm1.783-11.934c3.944 0 4.579-.4 5.967 3.729H13.392c1.392-4.136 1.889-3.729 5.967-3.729zm-8.531 8.531a1.512 1.512 0 011.075-2.564c.981-.093 3.373 2.338 1.631 2.89-.568.078-2.157.321-2.706-.326z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 116",
    transform: "translate(7.303 7.95)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 116",
    d: "M18 12a6 6 0 106 6 6.018 6.018 0 00-6-6z",
    fill: "#ef5323"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 125",
    fill: "#fff",
    d: "M17 17h2v5h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(17 14)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.5d067c1b61e32bdaef98e910bedc2faa.svg";
export { ForwardRef as ReactComponent };